export const customFlat = <T>(arr: T[][]) => {
  return arr.reduce((a, b) => a.concat(b), []);
};
